/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type StoryActionsContainer_viewer = {
    readonly id: string;
    readonly role: USER_ROLE;
    readonly " $refType": "StoryActionsContainer_viewer";
};
export type StoryActionsContainer_viewer$data = StoryActionsContainer_viewer;
export type StoryActionsContainer_viewer$key = {
    readonly " $data"?: StoryActionsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StoryActionsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryActionsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'c8ac582e34bf09c19c6b9d5961f5ba72';
export default node;
